import { gql } from "@apollo/client";
import { SessionContext } from "gui/session/session";
import { useGetUserFreeTeamsCountQuery } from "lib/types/graphql";
import { SessionWithUser } from "lib/users/types";
import { useContext } from "react";

export const useUserCanHaveFreeTeam = () => {
  const { session, sessionLoading } = useContext(SessionContext);

  const { data } = useGetUserFreeTeamsCountQuery({
    skip: !session || !session.user,
    context: { session },
    variables: {
      user_id: (session as SessionWithUser)?.user?.id,
    },
  });

  if (!sessionLoading && !session) {
    return true;
  }

  if (!data || !data.teams_aggregate.aggregate) {
    return false;
  }

  return data.teams_aggregate.aggregate.count <= 3;
};

gql`
  query GetUserFreeTeamsCount($user_id: Int!) {
    teams_aggregate(
      where: {
        memberships: {
          user_id: { _eq: $user_id }
          private_details: { role: { _eq: "admin" } }
        }
        members_details: { service_tier_id: { _eq: 1 } }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
